export const DASHBOARD_CONSTANTS: any = {
  crossSellDefaultCopy: {
    title: 'Start a new quote today',
    text: 'We’ve pre-filled your details to make it quick',
    actionText: 'View my quote'
  }
};
